import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "src/componets/Buttons";
import { setEditId, BundleInterface } from "src/store/callrecorder/bundlesSlice";
import { updateBundle } from "src/actions/callrecorder/bundlesActions";
import { EntityId } from "@reduxjs/toolkit";
import usePermissions from "src/hooks/usePermissions";
import { formattedDate } from "src/helpers/DateHelpers";
import OptionalLink from "src/componets/OptionalLink";
import Pagination from "src/componets/Pagination";
import PlatformIcon from "../../_partials/PlatformIcon";

import { Button, Space, Tag } from "antd";
import { StarFilled, StarOutlined } from "@ant-design/icons";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.callrecorder.bundles.ids);
  const bundles = useAppSelector(state => state.callrecorder.bundles.entities);
  const count = useAppSelector(state => state.callrecorder.bundles.count);
  const { write_callrecorder } = usePermissions();
  const data  = ids ? ids.map(id => bundles[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickFavorite({ id, favorite }: BundleInterface) {
    dispatch(updateBundle({ id, data: { favorite: !favorite } }));
  }

  const renderFavorite = (bundle: BundleInterface) => {
    const icon = bundle.favorite ? <StarFilled style={{ color: '#faad14' }} /> : <StarOutlined />;

    if (!write_callrecorder) {
      return icon;
    }

    return (
      <Button
        type='text'
        size='small'
        icon={icon}
        onClick={() => onClickFavorite(bundle)}
      />
    );
  };

  const renderEnvLabel = (prod_env: boolean) => {
    if (prod_env) {
      return <Tag color="success">production</Tag>
    } else {
      return <Tag color="default">development</Tag>
    }
  }

  const columns: ColumnsType<BundleInterface> = [
    {
      key: 'favorite',
      title: '',
      render: (_, bundle) => renderFavorite(bundle),
      width: 40
    },

    {
      key: 'name',
      title: 'Name',
      render: (_, { name, url, platform }) => (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ display: 'inline-block', minWidth: '13px' }}>
            <PlatformIcon platform={platform} />
          </span>
          <OptionalLink link={url}>{name}</OptionalLink>
        </span>
      ),
      width: 160,
      ellipsis: true
    },

    {
      key: 'prod_env',
      title: 'Environment',
      render: (_, { prod_env }) => renderEnvLabel(prod_env),
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    ...(write_callrecorder ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id }: BundleInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
